"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Names = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Displays brand name and name of a product.
 * Does not render if both `brandName` and `productName` have falsy value.
 * Does not render BrandName if `brandName` has falsy value, the same goes for ProductName and `productName`.
 */
const Names = ({
  brandName,
  brandUrl,
  className,
  productName,
  productUrl,
  size = 'medium'
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  if (!brandName && !productName) {
    return null;
  }
  const productNameVariant = size === 'small' ? 'subtitle1' : 'h5';
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    className: className,
    "data-testid": getTestId(_constants.NAMES),
    children: [brandName && !brandUrl ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BrandName, {
      variant: "caption",
      fontWeight: "bold",
      color: "textPrimary",
      "data-testid": getTestId(_constants.NAMES_BRAND_NAME),
      size: size,
      children: brandName
    }) : null, brandName && brandUrl ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BrandNameLink, {
      variant: "caption",
      fontWeight: "bold",
      color: "textPrimary",
      "data-testid": getTestId(_constants.NAMES_BRAND_NAME),
      href: brandUrl,
      size: size,
      children: brandName
    }) : null, productName && !productUrl ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ProductName, {
      "data-testid": getTestId(_constants.NAMES_PRODUCT_NAME),
      variant: productNameVariant,
      component: size === 'small' ? 'h3' : 'h1',
      color: "textPrimary",
      fontWeight: "bold",
      children: productName
    }) : null, productName && productUrl ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ProductNameLink, {
      "data-testid": getTestId(_constants.NAMES_PRODUCT_NAME),
      href: productUrl,
      variant: productNameVariant,
      color: "textPrimary",
      fontWeight: "bold",
      children: productName
    }) : null]
  });
};
exports.Names = Names;
